import { SearchRelevancyGrade } from '@aibees/shared/definition';
import { CircularProgressProps } from '@mui/material';
import { RelevancySummaryItem } from '../relevancy-summary-popup-content/types';

export const config: RelevancySummaryItem[] = [
  {
    grade: 'A',
    percent: 90,
    value: '90 - 100',
    title: 'Very High Relevance',
    stopColor1: '#0EBF75',
    stopColor2: '#0EBF75',
  },
  {
    grade: 'B',
    percent: 80,
    value: '70 < 90',
    title: 'High Relevance',
    stopColor1: '#1851EF',
    stopColor2: '#0E2E89',
  },
  {
    grade: 'C',
    percent: 50,
    value: '50 < 70',
    title: 'Medium Relevance',
    stopColor1: '#FFCC01',
    stopColor2: '#FFCC01',
  },
  {
    grade: 'D',
    percent: 20,
    value: '0 < 50',
    title: 'Low Relevance',
    stopColor1: '#FE800B',
    stopColor2: '#FE800B',
  },
];

export const statusColor: {
  [key in SearchRelevancyGrade]: CircularProgressProps['color'];
} = {
  A: 'success',
  B: 'primary',
  C: 'warning',
  D: 'error',
};
